var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contents.events{\n  height: 100%;\n  /* border: 1px solid black; */\n  width: 100%;\n  \n  \n\n}\n#events {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n          flex-direction: row;\n  -webkit-justify-content: center;\n          justify-content: center;\n  /* outline: 1px solid orange; */\n  width: 100%;\n}\n.event {\n  margin-top: 5%;\n  margin-left: 25%;\n  background-image: url(" + escape(require("../media/forsaleonamazon_1.jpg")) + ");\n  background-repeat: no-repeat;\n  height: 35%;\n  width: 100%;\n  background-size: contain;\n  max-width: 50vw;\n\n}\n#events img {\n  width: 15%;\n}", ""]);

// exports
